import { Badge } from '@/components/ui/Badge';

import { describeStatus } from '../status';

export function StatusBadge({ status }: { status: string | null }) {
  const presentation = describeStatus(status);
  return <Badge tone={presentation.tone}>{presentation.label}</Badge>;
}
